import * as React from 'react';
import { useNavigate } from 'react-router-dom';

interface AppLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  history?: 'auto' | 'push' | 'replace';
}

/**
 * Toolpad's default link always calls preventDefault, so ctrl/cmd/middle clicks
 * can't open a new tab. This one lets modified clicks fall through to the anchor.
 */
const AppLink = React.forwardRef<HTMLAnchorElement, AppLinkProps>(function AppLink(
  { children, href, onClick, history, ...rest },
  ref,
) {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const isModified =
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0;

    if (!isModified) {
      event.preventDefault();
      const url = new URL(event.currentTarget.href);
      navigate(url.pathname + url.search, {
        replace: history === 'replace',
      });
    }

    onClick?.(event);
  };

  return (
    <a ref={ref} href={href} {...rest} onClick={handleClick}>
      {children}
    </a>
  );
});

export default AppLink;
